import { render, staticRenderFns } from "./QuestionMark.vue?vue&type=template&id=49bee512&functional=true&"
import script from "./QuestionMark.js?vue&type=script&lang=js&"
export * from "./QuestionMark.js?vue&type=script&lang=js&"
import style0 from "./QuestionMark.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports